import { API } from '../constants/urls';
import authCrudder from './auth';

export const authAPI = authCrudder(API, "auth");